import product1 from "./assets/1.png";
import product2 from "./assets/2.png";
import product3 from "./assets/3.png";
import product4 from "./assets/4.jpeg";
import product5 from "./assets/5.jpg";
import product6 from "./assets/6.webp";
import product7 from "./assets/7.png";
import product8 from "./assets/8.webp";
import product9 from "./assets/9.jpg";

export const PRODUCTS = [
  {
    id: 1,
    productName: "iPhone 12 Pro",
    price: 999.0,
    productImage: product1,
  },
  {
    id: 2,
    productName: "Macbook Pro 2022 (M1)",
    price: 1999.0,
    productImage: product2,
  },
  {
    id: 3,
    productName: "Cannon M50",
    price: 699.0,
    productImage: product3,
  },
  {
    id: 4,
    productName: "iPad Pro 2022",
    price: 1399.0,
    productImage: product4,
  },
  {
    id: 5,
    productName: "JBL Extreme 3",
    price: 319.0,
    productImage: product5,
  },
  {
    id: 6,
    productName: "Playstation 5",
    price: 399.0,
    productImage: product6,
  },
  {
    id: 7,
    productName: "Fitbit Versa",
    price: 120.0,
    productImage: product7,
  },
  {
    id: 8,
    productName: "Meta Quest 2",
    price: 399.0,
    productImage: product8,
  },
  {
    id: 9,
    productName: "Beats Solo 2",
    price: 169.0,
    productImage: product9,
  } 
];